import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiConfig, McpProviderUiModule } from './types';

export const edularProviderUiModule: McpProviderUiModule = {
  providerCode: 'edular',
  matches: (integration: ManagedMcpIntegration) =>
    integration.transportType === 'adapter_http' &&
    (integration.name?.toLowerCase().includes('edular') ||
      integration.metadata?.adapterProvider === 'edular'),
  getUiConfig: (_integration: ManagedMcpIntegration): McpProviderUiConfig => ({
    providerCode: 'edular',
    displayName: 'Edular',
    // All base URLs (edular-core, calendar-api, auth) live on the MCP server's own metadata JSON
    // (MCP Catalogue → this server → Metadata, super-admin only) — no per-connection override here.
    showEndpointOverride: false,
    extraAuthFields: [
      {
        key: 'slug',
        label: 'Tenant Slug',
        placeholder: 'your-school-slug',
        helperText: 'This agent’s Edular tenant/school slug.',
      },
    ],
  }),
};
